module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/603107a7e5f62e4f9677616d9cc0afec.png";